import styled from "styled-components";
import Variables from "../../../assets/styleVariables";

export const Modal = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  display: ${props => (props.show ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  background: rgba(256, 256, 256, 0.5);
  z-index: 100000;
  .mapsa-back-1 {
    position: absolute;
    top: 10px;
    left: 10px;
  }
`;
export const Title = styled.div`
  font-size: ${Variables.font_sizes.x2_medium};
  color: ${Variables.colors.complementary_900};
  text-align: right;
  padding: 5px 0 10px 0;
`;

export const Description = styled.div`
  font-size: ${Variables.font_sizes.medium};
  color: ${Variables.colors.complementary_600};
  text-align: justify;
  padding: 5px 0 24px 40px;
`;

export const SearchInput = styled.div`
  display: flex;
  margin: 0 -20px 10px 10px;
  background: ${Variables.colors.complementary_300};
  border-radius: 5px;
  padding: 10px;
  i {
    padding-left: 10px;
  }
  input {
    background: transparent;
    border: none;
    outline: none;
  }
`;

export const ScrollBox = styled.div`
  margin: 0 -20px 60px 8px;
  max-height: calc(70vh - 60px);
  min-width: 300px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  text-align: right;
  color: ${Variables.colors.complementary_900};
  & > div {
    margin-bottom: 10px;
  }
`;

export const ActionBox = styled.div`
  position: absolute;
  bottom: 8px;
  right: 8px;
  width: calc(100% - 16px);
  display: flex;
  flex-direction: row;
  padding: 10px;
  background: white;
  border-radius: 5px;
  box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.16);
  justify-content: space-between;
  & > div {
    margin-left: 10px;
  }
`;
